export interface ProductInfo {
  id: string;
  name: string;
  fullName: string;
  label: string;
  color: string;
  tagline: string;
  description: string;
  heroImage: string;
  galleryImages: string[];
  targetUser: string;
  price: number;
  priceNote: string;
  features: { icon: string; title: string; desc: string }[];
  specs: { label: string; value: string }[];
  highlights: string[];
  caseStudy: { company: string; quote: string; role: string };
}

export const productData: Record<string, ProductInfo> = {
  core: {
    id: 'core',
    name: 'Core',
    fullName: 'MeVER Chair Core',
    label: '集中',
    color: '#5a5a6e',
    tagline: '集中力を最大化する、戦略的ミドルレンジ',
    description: '一般企業オフィスにちょうど良いルックスと高機能をリーズナブルに。標準デスクワークの快適性を最大化し、社員の集中力を引き出すワークチェアです。コストパフォーマンスに優れながら、BIFMA認証の品質と3年保証の安心感を兼ね備えています。',
    heroImage: 'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/f4a7d90296f789d46c6753357c7a51a3.png',
    galleryImages: [
      'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/f4a7d90296f789d46c6753357c7a51a3.png',
      'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/0bdf0db15694aa110ad41d499c132e61.jpeg',
      'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/8b2a5c12780a7fa641f0d730406d37dc.jpeg',
      'https://public.readdy.ai/ai/img_res/fac57143-8188-44e3-8274-e37c246fc69d.png',
    ],
    targetUser: '一般企業オフィス / バックオフィス / 標準デスクワーク',
    price: 79200,
    priceNote: '税込・送料込',
    features: [
      { icon: 'ri-focus-3-line', title: '集中力維持設計', desc: '人間工学に基づいた座面・背面設計が、長時間の集中をサポート。姿勢の崩れを防ぎ、業務効率を維持します。' },
      { icon: 'ri-money-yen-circle-line', title: 'コストパフォーマンス', desc: 'BIFMA認証の高品質をリーズナブルな価格で実現。大量導入にも最適な価格設計です。' },
      { icon: 'ri-shield-check-line', title: 'BIFMA認証・3年保証', desc: '国際基準の品質認証を取得。3年間の長期保証で、安心してご利用いただけます。' },
      { icon: 'ri-layout-grid-line', title: '標準デスク最適化', desc: '一般的なオフィスデスクとの相性を徹底的に追求。どんなオフィス環境にも自然に馴染みます。' },
      { icon: 'ri-armchair-line', title: '快適メッシュバック', desc: '通気性に優れたメッシュ素材が、長時間の着座でも蒸れを防ぎ快適な座り心地を提供します。' },
      { icon: 'ri-hand-heart-line', title: '4Dアームレスト', desc: '上下・前後・左右・角度の4軸調整可能なアームレストが、肩・腕の負担を軽減。デスクワークの疲労を最小化します。' },
    ],
    specs: [
      { label: '座面高さ', value: '45cm〜53cm（無段階調整）' },
      { label: '背もたれ', value: 'メッシュバック（通気性素材）' },
      { label: 'アームレスト', value: '4Dアームレスト（4軸調整）' },
      { label: 'キャスター', value: 'ナイロン製静音キャスター' },
      { label: '耐荷重', value: '135kg' },
      { label: 'リクライニング', value: '最大135度' },
      { label: '保証期間', value: '3年間' },
      { label: '認証', value: 'BIFMA認証取得' },
    ],
    highlights: [
      '一般企業オフィスに最適なデザインと機能性のバランス',
      '4Dアームレストを搭載しながら大量導入に対応するコストパフォーマンス',
      '標準デスク環境での集中力維持を最大化',
      'メンテナンスフリーで管理コストを削減',
    ],
    caseStudy: {
      company: '中堅IT企業（従業員200名）',
      quote: 'Core導入後、社員アンケートで「集中しやすくなった」と回答した割合が78%に。コスト面でも全席導入が実現でき、オフィス全体の生産性が向上しました。',
      role: '総務部長',
    },
  },
  pro: {
    id: 'pro',
    name: 'Pro',
    fullName: 'MeVER Chair Pro v2.0',
    label: '創造性',
    color: '#8E7CC3',
    tagline: '創造性を解放する、ハイエンドクラス',
    description: '6Dアームレストが電動昇降デスクとの相性抜群。クオリティを妥協したくないクリエイターやビジネスマンの創造性を最大限に引き出します。15ヶ所の調整ポイントが長時間の高負荷作業でも疲労を最小化し、パフォーマンスを維持し続けます。',
    heroImage: 'https://public.readdy.ai/ai/img_res/05671016-0778-4608-bc87-fdd4f5aef727.png',
    galleryImages: [
      'https://public.readdy.ai/ai/img_res/05671016-0778-4608-bc87-fdd4f5aef727.png',
      'https://public.readdy.ai/ai/img_res/74674580-8324-4438-8b42-0fa1bfc34e9f.png',
      'https://public.readdy.ai/ai/img_res/cd860c80-2367-482c-b54e-1f7029551f2e.png',
      'https://public.readdy.ai/ai/img_res/acfa2b97-77b6-47ec-a4af-16231ede71ee.png',
    ],
    targetUser: 'クリエイター / エンジニア / ビジネスマン / 電動昇降デスクユーザー / ミュージシャン',
    price: 123200,
    priceNote: '税込・送料込',
    features: [
      { icon: 'ri-lightbulb-flash-line', title: '創造性解放設計', desc: '身体の自由度を最大化する設計思想。姿勢の制約から解放され、アイデアが自然に湧き出る環境を実現します。' },
      { icon: 'ri-hand-coin-line', title: '6Dアームレスト', desc: '上下・前後・左右・回転・角度・幅の6軸調整が可能。あらゆる作業姿勢に完璧にフィットします。' },
      { icon: 'ri-arrow-up-down-line', title: '電動昇降デスク対応', desc: '立ち座りの切り替えに最適化された設計。電動昇降デスクとの組み合わせで最大のパフォーマンスを発揮します。' },
      { icon: 'ri-shield-star-line', title: '高剛性アルミフレーム', desc: '航空機グレードのアルミニウム合金フレームが、長期間の使用でも変形しない耐久性を実現します。' },
      { icon: 'ri-timer-flash-line', title: '長時間疲労最小化', desc: '体圧分散設計と動的サポート機構が、8時間以上の連続作業でも疲労を最小限に抑えます。' },
      { icon: 'ri-award-line', title: 'プレミアム品質', desc: 'BIFMA認証に加え、独自の耐久テストをクリア。プロフェッショナルの要求に応える最高品質です。' },
    ],
    specs: [
      { label: '座面高さ', value: '45cm〜53cm（無段階調整）' },
      { label: '背もたれ', value: 'ハイバックメッシュ（高弾性素材）' },
      { label: 'アームレスト', value: '6Dアームレスト（6軸調整）' },
      { label: 'フレーム', value: '高剛性アルミニウム合金' },
      { label: '耐荷重', value: '135kg' },
      { label: 'リクライニング', value: '最大135度（4段階ロック）' },
      { label: '保証期間', value: '3年間' },
      { label: '認証', value: 'BIFMA認証取得' },
    ],
    highlights: [
      '6Dアームレストによる完璧なフィット感',
      '電動昇降デスクとの最適な組み合わせ',
      '長時間の高負荷作業でもパフォーマンス維持',
      '在日米軍基地でのメイン導入実績',
    ],
    caseStudy: {
      company: '在日米軍基地',
      quote: 'Pro導入により、長時間のオペレーション業務における集中力と快適性が大幅に向上。特に6Dアームレストの評価が高く、作業効率の改善を実感しています。',
      role: '施設管理担当',
    },
  },
  style: {
    id: 'style',
    name: 'Style',
    fullName: 'MeVER Chair Style',
    label: '回復力',
    color: '#5a8a6a',
    tagline: '回復力を高める、ウェルネス特化モデル',
    description: 'バランスボール代替品として、体幹を自然に刺激。健康志向ユーザーの回復力を高め、職場全体のウェルビーイングを底上げします。座るだけで姿勢改善と体幹強化を同時に実現する、新しいカテゴリーのワークチェアです。',
    heroImage: 'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/0e5886a34ba8b9935f350bf408063f8e.png',
    galleryImages: [
      'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/0e5886a34ba8b9935f350bf408063f8e.png',
      'https://public.readdy.ai/ai/img_res/1ab5fc08-17f2-446c-b2ca-ccdb5bd81ee2.png',
      'https://public.readdy.ai/ai/img_res/7424ca48-6b71-4276-9e64-273d2e57ca4d.png',
      'https://public.readdy.ai/ai/img_res/09893465-6bdf-4998-849d-1207d45530dd.png',
    ],
    targetUser: '健康志向ユーザー / ウェルネス重視 / バランスボール愛用者',
    price: 69300,
    priceNote: '税込・送料込',
    features: [
      { icon: 'ri-heart-pulse-line', title: '回復力向上設計', desc: '体幹を自然に刺激する座面設計が、身体の回復力を高めます。疲労の蓄積を防ぎ、持続的なパフォーマンスを支えます。' },
      { icon: 'ri-basketball-line', title: 'バランスボール効果', desc: 'バランスボールの原理を応用した座面が、無意識のうちに体幹を鍛えます。座るだけで健康投資になります。' },
      { icon: 'ri-body-scan-line', title: '体幹刺激座面', desc: '微細な揺れを生み出す独自の座面構造が、インナーマッスルを自然に活性化。姿勢改善効果も期待できます。' },
      { icon: 'ri-leaf-line', title: 'ナチュラルフィット', desc: '身体の自然な動きに寄り添う設計。固定された姿勢ではなく、動的な座り心地で身体への負担を軽減します。' },
      { icon: 'ri-mental-health-line', title: 'ウェルビーイング向上', desc: '身体的な快適さが精神的な健康にも好影響。職場全体のウェルビーイングスコア向上に貢献します。' },
      { icon: 'ri-user-smile-line', title: '姿勢改善サポート', desc: '座るだけで正しい姿勢を自然にキープ。腰痛予防や肩こり軽減など、長期的な健康効果が期待できます。' },
    ],
    specs: [
      { label: '座面高さ', value: '43cm〜51cm（無段階調整）' },
      { label: '座面構造', value: '体幹刺激座面（バランスボール原理）' },
      { label: 'アームレスト', value: '高さ調整式アームレスト' },
      { label: 'フレーム', value: 'スチールフレーム（ナチュラルフィット機構）' },
      { label: '耐荷重', value: '135kg' },
      { label: 'リクライニング', value: '最大125度' },
      { label: '保証期間', value: '3年間' },
      { label: '認証', value: 'BIFMA認証取得' },
    ],
    highlights: [
      'バランスボール代替として体幹を自然に強化',
      '座るだけで姿勢改善・腰痛予防',
      '職場全体のウェルビーイング向上に貢献',
      'favy新宿でのメイン導入実績',
    ],
    caseStudy: {
      company: 'favy新宿（コワーキングスペース）',
      quote: 'Style導入後、利用者から「長時間座っても疲れにくい」「姿勢が良くなった」という声が多数。健康志向の利用者からの評価が特に高く、施設の差別化要因になっています。',
      role: '施設マネージャー',
    },
  },
};
